export default __webpack_public_path__ + "static/media/logo.63d2bb52.svg";